<script setup>
import { ref, computed, watchEffect, useTemplateRef, onMounted } from 'vue';

  const minModel = defineModel('minModel', { type: Number });
  const maxModel = defineModel('maxModel', { type: Number });

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  });

  const emit = defineEmits(['change']);

  const minInputRef = useTemplateRef('min-input-ref');
  const maxInputRef = useTemplateRef('max-input-ref');

  const minPercent = computed(() => ((minModel.value - props.min) / (props.max - props.min)) * 100);
  const maxPercent = computed(() => ((maxModel.value - props.min) / (props.max - props.min)) * 100);

  const styles = computed(() => ({
    '--jwx-slider-range-start': `${minPercent.value}%`,
    '--jwx-slider-range-end': `${maxPercent.value}%`
  }));

  function onMinInput() {
    if (minModel.value > maxModel.value) {
      minModel.value = maxModel.value;
    }
  }

  function onMaxInput() {
    if (maxModel.value < minModel.value) {
      maxModel.value = minModel.value;
    }
  }

  function onChange() {
    emit('change');
  }

  // onMounted(() => {
  //   minModel.value = minModel.value;
  //   maxModel.value = maxModel.value;
  // })

  // watchEffect(() => {
  //   if (!minInputRef.value) return;

  //   minInputRef.value.min = props.min;
  //   minInputRef.value.max = props.max;
  //   minInputRef.value.value = minModel.value;
  // })

  // watchEffect(() => {
  //   if (!maxInputRef.value) return;

  //   maxInputRef.value.min = props.min;
  //   maxInputRef.value.max = props.max;
  //   maxInputRef.value.value = maxModel.value;
  //   console.log("🚀 ~ RangeSliderDual.vue ~ maxModel.value:", maxModel.value)
  //   console.log("🚀 ~ RangeSliderDual.vue ~ maxInputRef.value.value:", maxInputRef.value.value)
  // })

  // watchEffect(() => {
  //   console.log("🚀 ~ RangeSliderDual.vue ~ maxModel.value:", maxModel.value)
  // })
</script>

<template>
  <div
    ref="trackRef"
    class="jwx-slider-control"
    :data-dual="true"
    :style="styles"
  >
    <input
      ref="min-input-ref"
      type="range"
      class="jwx-slider-control__input jwx-slider-control__input--min"
      :name="`${id}-min`"
      :id="`${id}-min`"
      :min="props.min"
      :max="props.max"
      :step="props.step"
      v-model.number="minModel"
      :disabled="disabled"
      @input="onMinInput"
      @change="onChange"
    />
    <input
      ref="max-input-ref"
      type="range"
      class="jwx-slider-control__input jwx-slider-control__input--max"
      :name="`${id}-max`"
      :id="`${id}-max`"
      :min="props.min"
      :max="props.max"
      :step="props.step"
      v-model.number="maxModel"
      :disabled="disabled"
      @input="onMaxInput"
      @change="onChange"
    />
  </div>
</template>
